// extracted by mini-css-extract-plugin
export default {"container":"UpgradePanels_container__pTCTR"};